/**
 * Generic tracking event emitter.
 *
 * Components emit vendor-agnostic business events here.
 * Vendor implementations (Bloomreach, GTM, etc.) subscribe and map
 * to their own event names and formats.
 */
import mitt from 'mitt';
import { EmitterEvent } from './constants';
export const emitter = mitt();
